import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../RTEEditable.interfaces';

export const UnorderedListElement: FC<IRTERenderElementProps> = (props) => {
  const { element, children } = props;
  const attributes = props.attributes ?? {};

  return (
    <ul {...element.attr} {...attributes} style={{ padding: 'revert' }}>
      {children}
    </ul>
  );
};
